import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.activeStep)
    ? (_openBlock(), _createBlock($setup["TutorialStep"], {
        key: $setup.activeStep.index,
        step: $setup.activeStep.step,
        first: $setup.activeStep.first,
        last: $setup.activeStep.last,
        stepIndex: $setup.activeStep.index,
        totalSteps: $setup.steps.length,
        onNext: $setup.next,
        onBack: $setup.back,
        onExitIntro: $setup.exitIntro
      }, null, 8 /* PROPS */, ["step", "first", "last", "stepIndex", "totalSteps"]))
    : _createCommentVNode("v-if", true)
}